export default (id) => ({
  fitlerId: 1,
  init() {
    this.fitlerId = id;
  },
  toggle(nextTab) {
    if (this.fitlerId === nextTab) return;
    this.fitlerId = nextTab;
  },
	handleDialog() {
		if (this.dialogOpen) {
			this.$refs.dialog.showModal();
		} else {
			this.$refs.dialog.close();
		}
	}
});
